import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionAddCardAssigneesCodes = {
  AutomationV2ExecutionActionAddCardAssigneesFailedToAddAssignee: {
    code: 'automation-v2-execution-action/add-card-assignees-failed-to-add-assignee',
    explanation: `Falha ao atribuir um usuário ao card.

**Causas comuns:**
- O usuário não tem permissão de acesso ao card ou pipe
- O usuário foi desativado
- O ID do usuário fornecido é inválido

**Como resolver:**
Verifique se o usuário alvo possui permissões adequadas no fluxo.`,
    localizations: {},
    message: 'A automação não conseguiu adicionar o responsável ao processo.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Responsável ao Card',
        path: '/wiki/docs/automations/actions/add-card-assignee',
      },
      {
        name: 'Gerenciamento de Responsáveis',
        path: '/wiki/docs/cards/tabs/general#responsáveis',
      },
    ],
  },
  AutomationV2ExecutionActionAddCardAssigneesMissingCardId: {
    code: 'automation-v2-execution-action/add-card-assignees-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message:
      'Não foi possível adicionar o responsável ao card porque o ID do card está faltando. Verifique se o card existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Responsável ao Card',
        path: '/wiki/docs/automations/actions/add-card-assignee',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionAddCardAssigneesNoAssigneesProvided: {
    code: 'automation-v2-execution-action/add-card-assignees-no-assignees-provided',
    explanation: `A lista de responsáveis a adicionar está vazia.

**Causas comuns:**
- Nenhum usuário foi selecionado na configuração
- A variável dinâmica de usuários retornou vazio

**Como resolver:**
Selecione pelo menos um usuário ou garanta que a variável dinâmica contenha IDs válidos.`,
    localizations: {},
    message: 'Nenhum responsável foi fornecido para adicionar ao card.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Responsável ao Card',
        path: '/wiki/docs/automations/actions/add-card-assignee',
      },
      {
        name: 'Gerenciamento de Responsáveis',
        path: '/wiki/docs/cards/tabs/general#responsáveis',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
